
/**
 * 微信内登录
 * @param {String} backUrl 登录后返回的地址
 * @return {Promise} 登录状态
 */
export default function login (backUrl = window.location.href) {
  const encode = window.encodeURIComponent
  const encodedCallbackUrl = encode(backUrl)
  // const apiUrl = encode(`https://course.auoktalk.com/API_V2/weixin/url/userinfo/v2?rd=${encodedCallbackUrl}`)
  const apiUrl = `https://course.auoktalk.com/api/weixin/url/userinfo/v2?rd=${encodedCallbackUrl}`

  // const apiUrl = `http://account.wps.cn/p/oauth/redirect_login?cb=${ cb }&utype=wechat_mp`
  // setTimeout(() => (location.href = apiUrl))

  // const wxLoginUrl = encode(`http://account.wps.cn/p/oauth/redirect_login?cb=${cb}&utype=wechat_mp`)
  // const apiUrl = `https://course.auoktalk.com/API_V2/weixin/redirect?url=${wxLoginUrl}`
  //
  // const apiUrl = `https://course.auoktalk.com/API_V2/weixin/redirect?url=${wxLoginUrl}`
  setTimeout(() => (window.location.href = apiUrl))
  return Promise.resolve({ msg: '跳转登录页面' })
}
